/**<params>说明
 * bgImgs 背景图片：string
 * position 文本框位置：string  left  top  bottom
 * title 标题
 * des 描述
 */
import Image from '@/components/UI/Image';
import EFProductNext from '@/components/UI/svg/Icons/EFProductNext';
import EFProductPrev from '@/components/UI/svg/Icons/EFProductPrev';
import { useGlobal } from '@/utils/useGlobal';
import SwiperCore, { A11y, Navigation, Pagination, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

const items = [
    { id: 1, bgImage: '/img/house.png', path: '' },
    { id: 2, bgImage: '/img/house.png', path: '' },
    { id: 3, bgImage: '/img/house.png', path: '' },
    { id: 4, bgImage: '/img/house.png', path: '' },
];
const configs = {
    pageText: false, //标识是否有标题
    slideWidth: undefined,
    slideHeight: 3.15,
    spaceBetween: 0,
    slidesPerView: 'auto',
    centeredSlides: false,
    loop: true,
    prevName: 'prevs',
    nextName: 'nexts',
    slidesOffsetBefore: 0,
    listTitleColor: '#919191',
    prevIcon: <EFProductPrev />,
    nextIcon: <EFProductNext />,
    iconWidth: 48,
    iconHeight: 48,
    iconLeftRightPosition: '40px',
    iconTopPosition: '',
    showPagination: true,
    imgWidth: 420,
    imgHeight: 520,
};
export default function BannerModule({ config, data = items }: any) {
    const configTypes = { ...configs, ...config };
    const { useState } = useGlobal();
    const [activeRef, setActiveRef] = useState({ type: false });
    const windowWidth = typeof window !== 'undefined' ? window.innerWidth : 0;
    const slidesPerViewcomputed = windowWidth / configTypes.slideWidth;

    let nextAndPrevPosition = 40;
    if (configTypes.slideWidth > 0) {
        nextAndPrevPosition = (windowWidth - configTypes.slideWidth) / 2;
    }
    return (
        <div className={css.SwiperModule} style={{ height: `${configTypes.slideHeight}rem` }}>
            <div
                style={{ top: configTypes.iconTopPosition }}
                className={configTypes.prevName == 'prevs' ? `prevs` : `otherprevs ${configTypes.prevName} swiper-button-hidden`}
            >
                {configTypes.prevIcon}
            </div>
            <Swiper
                className="swipers"
                height={configTypes.slideHeight}
                pagination={
                    configTypes.showPagination
                        ? {
                              clickable: true,
                              // bulletClass:configTypes.pageText?'swiper-pagination-bullet':''
                          }
                        : false
                }
                initialSlide={0}
                loop={configTypes.loop}
                preloadImages={false}
                lazy={true}
                observer={true} //修改swiper自己或子元素时，自动初始化swiper
                observeParents={true} //修改swiper的父元素时，自动初始化swiper
                //  width={configTypes.slideWidth>0?configTypes.slideWidth*data.length:undefined}
                slidesPerView={1}
                spaceBetween={configTypes.spaceBetween}
                centeredSlides={configTypes.centeredSlides}
                slidesOffsetBefore={configTypes.slidesOffsetBefore}
                navigation={{
                    nextEl: `.${configTypes.nextName}`,
                    prevEl: `.${configTypes.prevName}`,
                }}
                onSlideChange={(swiper) => {
                    setActiveRef({ type: true });
                    swiper.navigation.init();
                }}
            >
                {configTypes.pageText &&
                    data.map((item: any, i: any) => (
                        <SwiperSlide
                            key={item.id}
                            style={{
                                width: configTypes.centeredSlides ? `${configTypes.slideWidth}px` : '100%',
                                height: `${configTypes.slideHeight}rem`,
                            }}
                            className="sidebox"
                        >
                            <span className="imgs">
                                <Image
                                    src={item.bgImage}
                                    width={configTypes.imgWidth}
                                    height={configTypes.imgHeight}
                                    className="fullImgs"
                                    alt={item.alt || item.title}
                                />
                            </span>
                            <p style={{ color: configTypes.listTitleColor }}>{item.title}</p>
                        </SwiperSlide>
                    ))}
                {!configTypes.pageText &&
                    data.map((item: any, i: any) => (
                        <SwiperSlide
                            key={item.id}
                            style={{
                                width: configTypes.centeredSlides ? `${configTypes.slideWidth}px` : '100%',
                                height: `${configTypes.slideHeight}rem`,
                            }}
                        >
                            <Image className="banner-img" src={item.bgImage} layout="fill" alt={item.alt || item.title} />
                        </SwiperSlide>
                    ))}
            </Swiper>
            <div style={{ top: configTypes.iconTopPosition }} className={configTypes.nextName == 'nexts' ? 'nexts' : `othernexts ${configTypes.nextName}`}>
                {configTypes.nextIcon}
            </div>
        </div>
    );
}
